import type { AiModelConnectionTestPayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelConnectionTested';
import type { AiUsageValuePayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries a model connection test result: `usage` is the usage tested against — distinct from
 * `ProviderConnectionTestView`, which carries a `models` listing instead of a single usage.
 */
class ModelConnectionTestView {
	readonly succeeded: boolean;
	readonly message: string;
	readonly testedAt: string;
	readonly usage: AiUsageValuePayload;
	readonly rejectedSettings: readonly string[];

	constructor(payload: AiModelConnectionTestPayload) {
		this.succeeded = payload.succeeded;
		this.message = payload.message;
		this.testedAt = payload.testedAt;
		this.usage = payload.usage;
		this.rejectedSettings = payload.rejectedSettings;

		Object.freeze(this);
	}
}

export default ModelConnectionTestView;
